import React, { useEffect, useState } from 'react';
import PDFViewer from './PDFViewer';
import { Invoice } from '../types';
import './PDFPage.css';

const PDFPage: React.FC = () => {
  const [invoice, setInvoice] = useState<Invoice | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Get invoice data from sessionStorage (set by parent window)
    const invoiceData = sessionStorage.getItem('invoiceData');
    const invoiceKey = sessionStorage.getItem('invoiceKey');
    
    console.log('PDFPage - Raw invoiceData from sessionStorage:', invoiceData);
    console.log('PDFPage - invoiceKey:', invoiceKey);
    
    if (invoiceData) {
      try {
        const parsedInvoice = JSON.parse(invoiceData);
        if (invoiceKey) {
          parsedInvoice.key = invoiceKey;
        }
        
        console.log('PDFPage - Parsed invoice:', parsedInvoice);
        console.log('PDFPage - Parsed invoice photos:', parsedInvoice.photos);
        console.log('PDFPage - Parsed invoice materials:', parsedInvoice.materials);
        
        setInvoice(parsedInvoice);
      } catch (error) {
        console.error('Error parsing invoice data:', error);
      }
    } else {
      console.log('PDFPage - No invoiceData found in sessionStorage');
    }
    
    setLoading(false);
  }, []);

  if (loading) {
    return (
      <div className="pdf-page-loading">
        <div className="loading-spinner"></div>
        <p>Carregando boletim...</p>
      </div>
    );
  }

  return (
    <div className="pdf-page">
      <PDFViewer invoice={invoice ?? undefined} />
    </div>
  );
};

export default PDFPage;